(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name userActivityReport.controller:UserActivityReportCtrl
   *
   * @description
   *
   */
  angular
    .module('userActivityReport')
    .controller('UserActivityReportCtrl', UserActivityReportCtrl);

  function UserActivityReportCtrl(ManageUserServices, CommonMasterData , CommonLogicService, $sce) {
    var vm = this;
    vm.ctrlName = 'UserActivityReportCtrl';

    vm.model = {
      searchPanelToggle: true,
      searchCriteria: {
        fromDate: null,
        toDate: null,
        fromTime: null,
        toTime: null,
        userType: null,
        userName: null,
        loginId: null
      },
      masterList: {
        userTypes: [],
        userList :[]
      },
    };
    vm.clickOnSearch = function() {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    vm.submitSearch = function(params) {
      searchUserActivityReport(params);
    };

    // on change search field
    vm.changeSearchField = function(searchParams, flag) {

      setDateValidationFlags();
      // if from date time before to date time
      if (!!vm.model.searchCriteria.fromDate
        && !!vm.model.searchCriteria.fromTime
        && !!vm.model.searchCriteria.toDate
        && !!vm.model.searchCriteria.toTime
        && !vm.model.masterList.fromDateFormatInvalid
        && !vm.model.masterList.toDateFormatInvalid
        && !vm.model.masterList.fromTimeInvalid
        && !vm.model.masterList.toTimeInvalid
        && !isFromDateBeforeToDate()) {
        vm.model.masterList.fromDateAfterToDate = true;
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
      }

      if (flag == 'userType') {
        vm.model.searchCriteria.userName = null;
        if (!!vm.model.searchCriteria.userType
          && !!vm.model.searchCriteria.userType.userTypeCode) {
          loadUserList(vm.model.searchCriteria.userType.userTypeCode);
        } else {
          vm.model.masterList.crewList = [];
        }
      } else if (flag == 'userName') {
        if (!!vm.model.searchCriteria.userName) {
          vm.model.searchCriteria.loginId = vm.model.searchCriteria.userName.loginId;
        }
      } else if (flag == 'crewId') {
        vm.model.searchCriteria.userType = null;
        vm.model.searchCriteria.userName = null;
        vm.model.masterList.userList = [];
      }
    };

// load crew list
    function loadUserList(userType) {
      CommonMasterData.searchUsersByType(userType, function(response) {
        vm.model.masterList.userList = response;
        vm.model.searchCriteria.userName = null;
      }, function() {
        console.log('User list retrieval error');
      });

    };

    function searchUserActivityReport(param) {
      vm.model.initialSearchDone = true;
      if (isValidSearchParams(param)) {
        vm.model.searchCriteria = param;
        vm.model.searchPanelToggle = false;
        var reportDesign = "userActivity.rptdesign";

        var url = CommonLogicService.getReportUrl(reportDesign,
          getSearchParamMap(param));
        vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
      }
    };

    function isValidSearchParams(params) {
      setDateValidationFlags();
      // if date invalid
      if (!!vm.model.searchCriteria.fromDate
        && !!vm.model.searchCriteria.fromTime
        && !!vm.model.searchCriteria.toDate
        && !!vm.model.searchCriteria.toTime) {
        if (vm.model.masterList.toDateFormatInvalid
          || vm.model.masterList.fromTimeInvalid
          || vm.model.masterList.fromDateFormatInvalid
          || vm.model.masterList.toTimeInvalid
          || vm.model.masterList.fromDateAfterToDate) {
          return false;
        } else {
          return true;
        }
      }
      return false;
    }

    ManageUserServices.searchUserTypes(
      function (userTypes) {
        vm.model.masterList.userTypes = userTypes;
      },
      function(error) {
        MessageService.error(error);
      }
    );


    function setDateValidationFlags() {
      // if from date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }
      // if to date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
      }
      // if from time invalid
      if (!isValidTime(vm.model.searchCriteria.fromTime)) {
        vm.model.masterList.fromTimeInvalid = true;
      } else {
        vm.model.masterList.fromTimeInvalid = false;
      }
      // if from time invalid
      if (!isValidTime(vm.model.searchCriteria.toTime)) {
        vm.model.masterList.toTimeInvalid = true;
      } else {
        vm.model.masterList.toTimeInvalid = false;
      }
    }

    // check from date and to date
    function isFromDateBeforeToDate() {
      return moment(
        vm.model.searchCriteria.fromDate + " "
        + vm.model.searchCriteria.fromTime,
        "DD/MM/YYYY HH:mm").isBefore(
        moment(vm.model.searchCriteria.toDate + " "
          + vm.model.searchCriteria.toTime,
          "DD/MM/YYYY HH:mm"));
    };
    // validate Date
    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    };

    function isValidTime(time) {
      var regex = /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/;
      return regex.test(time);
    };

    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["fromDate"] = param.fromDate;
      searchParamMap["toDate"] = param.toDate;
      searchParamMap["fromTime"] = param.fromTime;
      searchParamMap["toTime"] = param.toTime;

      if (!!param.userType && !!param.userType.userTypeCode) {
        searchParamMap["userType"] = param.userType.userTypeCode;
      }

      if (!!param.loginId ) {
        searchParamMap["loginId"] = param.loginId;
      }
      return searchParamMap;
    }

  }
}());
